import { render, staticRenderFns } from "./WorkprojectbudgetChange.vue?vue&type=template&id=09b7f673&scoped=true&"
import script from "./WorkprojectbudgetChange.vue?vue&type=script&lang=js&"
export * from "./WorkprojectbudgetChange.vue?vue&type=script&lang=js&"
import style0 from "./WorkprojectbudgetChange.vue?vue&type=style&index=0&id=09b7f673&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7f673",
  null
  
)

export default component.exports